import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const LegalLayout = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#205F79] transition-colors"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={18} />
            Retour à l'accueil
          </button>
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="DIP PILOTE +IA" className="h-8 w-8 object-contain" />
            <span className="font-semibold text-[#205F79]">DIP PILOTE +IA</span>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 sm:p-12">
          <div className="flex items-start gap-3 mb-2">
            <FileText className="text-[#205F79] mt-1" size={24} />
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">{title}</h1>
          </div>
          {lastUpdated && (
            <p className="text-sm text-gray-500 mb-8 ml-9">
              Dernière mise à jour : {lastUpdated}
            </p>
          )}
          <div className="legal-content prose prose-sm max-w-none text-gray-700 space-y-6">
            {children}
          </div>
        </div>

        <p className="text-center text-xs text-gray-400 mt-8">
          DIP PILOTE +IA · Logiciel SaaS dédié aux artisans cosmétiques
        </p>
      </main>
    </div>
  );
};

export default LegalLayout;
